// Code Generated By 'npm run config', Please DO NOT Edit!!!!! 
        
const clientConfig = {
    appId: "cli_a9c66475e1781cca", //网页应用appId
    getUserAccessTokenPath:  "/api/get_user_access_token", //免登api path
    getSignParametersPath:  "/api/get_sign_parameters", //鉴权api path;
    apiPort: "8989",   //后端指定端口
}
    
export default clientConfig;